// OIDC configuration sourced from Vite env. All values are public (PKCE SPA flow).
import { WebStorageStateStore, type UserManagerSettings } from 'oidc-client-ts';

const issuer = import.meta.env.VITE_ZITADEL_ISSUER ?? '';
const clientId = import.meta.env.VITE_ZITADEL_CLIENT_ID ?? '';
const redirectUri =
  import.meta.env.VITE_OIDC_REDIRECT_URI ?? `${window.location.origin}/auth/callback`;

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

/**
 * UserManager settings for ZITADEL via Authorization Code + PKCE.
 *  - `authority` triggers OIDC discovery (`/.well-known/openid-configuration`).
 *  - `response_type: code` + a public client (no secret) => PKCE is automatic.
 *  - Silent renew uses a hidden iframe pointed at `silent_redirect_uri`.
 *  - Tokens are persisted in localStorage so a full reload keeps the session.
 */
export const oidcSettings: UserManagerSettings = {
  authority: issuer,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: window.location.origin,
  silent_redirect_uri: `${window.location.origin}/auth/silent-renew`,
  response_type: 'code',
  // `openid profile email` for identity; ZITADEL needs these to emit the project
  // roles claim that normalizeClaims() reads.
  scope: 'openid profile email urn:zitadel:iam:org:project:roles',
  automaticSilentRenew: true,
  loadUserInfo: false,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export const oidcConfigured = Boolean(issuer && clientId);
